import Emitter from 'component-emitter';

export const emitter = new Emitter();
